export var OperationCreate;
(function (OperationCreate) {
    let type;
    (function (type) {
        type["ADD"] = "add";
        type["EDIT"] = "edit";
        type["DELETE"] = "delete";
        type["TRANSFER"] = "transfer";
    })(type = OperationCreate.type || (OperationCreate.type = {}));
})(OperationCreate || (OperationCreate = {}));
